export default {
  home: {
    matchups: {
      today: "Matchup di oggi",
      thisWeek: "Matchup di questa settimana",
      upcoming: "Prossimi matchup",
    },
    actions: {
      showMore: "Mostra di più",
      showLess: "Mostra meno",
    },
    empty: {
      parlayMinGames: "Nessun trend ancora disponibile. Servono almeno 3 partite.",
    },
    hundredPercentClub: {
      subtitle: "Props che hanno centrato il 100% delle partite",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Trova valore quando cambiano le formazioni iniziali. Incluso con",
        injuryImpact: "Vedi come gli infortuni impattano i compagni. Incluso con",
        opponentRank: "Sfrutta matchup difensivi favorevoli. Incluso con",
        startingPitchers: "Punta spot contro lanciatori vulnerabili. Incluso con",
        weatherReport: "Usa vento e meteo a tuo vantaggio. Incluso con",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Caricamento dei mercati...",
        loadError: "Impossibile caricare i mercati.",
      },
    },
    sidebar: {
      improveExperience: "Migliora la tua esperienza Linemate",
      getAccess: "ACCEDI A GIOCATE AVANZATE E INSIGHT PIÙ PROFONDI",
    },
  },
};
